module.exports = __webpack_public_path__ + "img/ContributeYourDataToBeDisplayedOnTheMap.4220bab6.svg";